import Cookies from "js-cookie";

const HeaderDashboard = ({ onMenuClick }) => {
  const user = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;

  return (
    <header className="flex items-center justify-between p-4 bg-white shadow">
      <div className="flex items-center gap-4">
        <button
          onClick={onMenuClick}
          className="p-2 rounded hover:bg-gray-100 lg:hidden">
          ☰
        </button>
      </div>

      {user && (
        <div className="flex items-center gap-3">
          <div className="text-right leading-tight hidden sm:block">
            <p className="text-sm font-semibold">{user.name}</p>
            <p className="text-xs text-gray-500">{user.email}</p>
          </div>

          <img
            src={user.image_url}
            alt="profil"
            className="h-10 w-10 rounded-full object-cover"
          />
        </div>
      )}
    </header>
  );
};

export default HeaderDashboard;
